/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_NoneInputs */

const en_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune`)
};

const de_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_options_pedal_action_none = /** @type {(inputs: Options_Pedal_Action_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Options_Pedal_Action_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_none = /** @type {((inputs?: Options_Pedal_Action_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_none(inputs)
	if (locale === "de") return de_options_pedal_action_none(inputs)
	if (locale === "it") return it_options_pedal_action_none(inputs)
	if (locale === "ru") return ru_options_pedal_action_none(inputs)
	if (locale === "es") return es_options_pedal_action_none(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_none(inputs)
	if (locale === "ja") return ja_options_pedal_action_none(inputs)
	if (locale === "hi") return hi_options_pedal_action_none(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_none(inputs)
	return en_options_pedal_action_none(inputs)
});